



























































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { getCatalog, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { trim } from "@/utils/commonUtil";

@Component({
  name: "fillInTable",
  components: {
    questionSettingTemplate,
    EditSortDialog,
  },
})
export default class fillInTable extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  private loading = false;
  private catalogList: any[] = [];
  private editSortDialogKey = Math.random();
  private postForm: any = {
    title: "请填写以下内容",
    itemScore: 0,
    required: 1,
    optionsList: [
      {
        value: "",
        content: "行标题",
        rightOption: false,
        otherInput: false,
        childList: [
          {
            value: "",
            content: "行标题1",

            rightOption: false,
            otherInput: false,
            inputMax: undefined,
            subTitle: "",
          },
        ],
      },
      {
        value: "",
        content: "列标题",
        rightOption: false,
        otherInput: false,
        childList: [
          {
            value: "",
            content: "列标题1",
            rightOption: false,
            otherInput: false,
          },
        ],
      },
    ],
    content: "",
    jsonConfig: {
      subTitle: "",
      showIndex: true,
      isCountTotalNumber: false,
      rowList: [],
      columnList: [],
      otherInputForm: "NONE",
      otherInputNumberMin: undefined,
      otherInputNumberMax: undefined,
      otherInputNumberPrecision: 0,
      otherInputMin: undefined,
      otherInputMax: undefined,
    },
  };

  private rules = {
    title: [{ required: true, message: "请输入标题", trigger: "blur" }],

    required: [{ required: true, message: "请选择是否必填", trigger: "blur" }],
    coontent: [{ required: false, type: "string", trigger: "blur" }],
    itemScore: [{ required: true, message: "请填写题目分值", trigger: "blur" }],
    rightText: [{ required: true, message: "请填写答案", trigger: "blur" }],
    scoreRule: [{ required: true, message: "请选择得分规则", trigger: "blur" }],
    // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
    whetherJoinQuestionBank: [{ required: true, message: "请选择是否加入题库", trigger: "blur" }],
  };

  get questionnaireType(): EnumCommunityType {
    return QuestionnaireEditModule.questionnaireType as any;
  }
  get communityType(): EnumCommunityType {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams(): any {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType,
    };
  }
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  removeOption(index: number, type: string) {
    if (type == "row") {
      this.postForm.jsonConfig.rowList.splice(index, 1);
    } else {
      this.postForm.jsonConfig.columnList.splice(index, 1);
    }
  }
  addOption(type: string) {
    if (type == "row") {
      this.postForm.jsonConfig.rowList.push({ value: "", content: "", rightOption: false, otherInput: false, inputMax: undefined, subTitle: "" });
    } else {
      this.postForm.jsonConfig.columnList.push({ value: "", content: "", rightOption: false, otherInput: false, inputMax: undefined, subTitle: "" });
    }
  }
  optionValidator(rule: any, value: string, callback: (err?: Error) => void) {
    if (value) {
      const str = trim(value);
      if (str.length == 0) {
        callback(Error("标题不能为空"));
      }
    } else {
      callback(Error("标题不能为空"));
    }
    callback();
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  remoteMethod(query?: any) {
    this.loading = true;
    getCatalog({ ...this.basicParams, name: query, pageSize: 50, pageNum: 1 })
      .then((res: any) => {
        this.catalogList = res.rows || [];
      })
      .finally(() => (this.loading = false));
  }
  catalogFocus() {
    if (this.catalogList.length === 0) {
      this.remoteMethod();
    }
  }
  openSortDialog() {
    (this.$refs.editSortDialog as any).onShow({ isBusinessTypeDisable: true, formData: { businessType: this.questionnaireType } });
  }
  async validate() {
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }

  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
